import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AppStore from '../../store/AppStore'
import HomeAction from '../actions/HomeAction'
import SideNav from './SideNav'
import Header from './Header'
import Help from './Help'
import { Wait } from 'react-aquasys'
import DtoUnit from '../../referential/dto/DtoUnit'
import DtoSiteType from '../../referential/dto/DtoSiteType'
import DtoFilterType from '../../referential/dto/DtoFilterType'
import DtoCity from '../../referential/dto/DtoCity'
import DtoParameter from '../../referential/dto/DtoParameter'
import DtoStandardCodification from '../../referential/dto/DtoStandardCodification'
import DtoSupport from '../../referential/dto/DtoSupport'
import DtoRemark from '../../referential/dto/DtoRemark'
import ReferentialAction from '../../referential/actions/ReferentialAction'
import DtoWatershed from '../../referential/dto/DtoWatershed'
import DtoSimpleStation from '../../referential/dto/DtoSimpleStation'
import CreditAction from '../actions/CreditAction'
import DtoCreditType from '../dto/DtoCreditType'
import DtoUserCredit from '../dto/DtoUserCredit'
import DtoUser from '../dto/DtoUser'
import SelectionAction from '../../dashboard/actions/SelectionAction'
import DtoSelection from '../../dashboard/dto/DtoSelection'
import DtoIndicatorType from '../../referential/dto/DtoIndicatorType'
import DtoIndicator from '../../referential/dto/DtoIndicator'
import Tutorial from './Tutorial'
import DtoManagementWater from '../../referential/dto/DtoManagementWater'
import MasterThemeDto from '../../administration/dto/MasterThemeDto'
import AdministrationAction from '../../administration/actions/AdministrationAction'
import { flattenDeep, uniq } from 'lodash'
import DtoSource from '../../administration/dto/DtoSource'
import DtoSelectionStatus from '../../dashboard/dto/DtoSelectionStatus'
import CookiePanel from '../../components/cookie/CookiePanel'
import { putAnalyticsCookieUser } from '../../utils/cookie/CookieUtils'
import LoginModal from '../../login/components/modal/LoginModal'
import DtoDepartment from '../../referential/dto/DtoDepartment'
import ToastrPanel from '../../components/toastr/ToastrPanel'
import InformationPanel from '../../components/information/InformationPanel'

const $ = window.$

class AquadbApp extends Component {

	constructor(props) {
		super(props)
		this.state = {
			login: '',
			header: 'Tableau de bord'
		}
	}

	componentWillMount() {
		AppStore.dispatch(AdministrationAction.fetchThemes())
		if (this.props.units.length === 0) {
			AppStore.dispatch(ReferentialAction.fetchUnits())
		}
		if (this.props.remarks.length === 0) {
			AppStore.dispatch(ReferentialAction.fetchRemarks())
		}
		if (this.props.standardCodifications.length === 0) {
			AppStore.dispatch(ReferentialAction.fetchStandardCodifications())
		}
		if (this.props.parameters.length === 0) {
			AppStore.dispatch(ReferentialAction.fetchParameters())
		}
		if (this.props.supports.length === 0) {
			AppStore.dispatch(ReferentialAction.fetchSupports())
		}
		if (this.props.cities.length === 0) {
			AppStore.dispatch(ReferentialAction.fetchCities())
		}
		if (this.props.departments.length === 0) {
			AppStore.dispatch(ReferentialAction.fetchDepartments())
		}
		if (this.props.filterTypes.length === 0) {
			AppStore.dispatch(ReferentialAction.fetchFilterTypes())
		}
		if (this.props.siteTypes.length === 0) {
			AppStore.dispatch(ReferentialAction.fetchSiteTypes())
		}
		if (this.props.indicatorTypes.length === 0) {
			AppStore.dispatch(ReferentialAction.fetchIndicatorTypes())
		}
		if (this.props.indicators.length === 0) {
			AppStore.dispatch(ReferentialAction.fetchIndicators())
		}
		if (!this.props.watersheds.length) {
			AppStore.dispatch(ReferentialAction.fetchWatersheds())
		}
		if (!this.props.stations.length && this.props.families.length) {
			const types = uniq(flattenDeep(this.props.families.map(f => {
				const themes = f.themes.filter(t => !t.disable)
				return themes.map(t => t.siteTypes.map(o => o.type))
			})))
			AppStore.dispatch(ReferentialAction.fetchSimpleStations(types))
		}
		if (!this.props.managementWaters.length) {
			AppStore.dispatch(ReferentialAction.fetchManagementWaters())
		}
		if (!this.props.creditTypes.length) {
			AppStore.dispatch(CreditAction.fetchCreditTypes())
		}
		if (!this.props.sources.length) {
			AppStore.dispatch(AdministrationAction.fetchSources())
		}
		if (!this.props.selectionStatus.length) {
			AppStore.dispatch(SelectionAction.fetchSelectionStatus())
		}
		if (this.getLogged()) {
			const token = sessionStorage.getItem('TOKEN')
			const login = atob(token)
			this.setState({ login: login })
			AppStore.dispatch(HomeAction.fetchUser(login))
			if (!this.props.selections.length) {
				AppStore.dispatch(SelectionAction.fetchSelections(login))
			}
			if (!this.props.userCredit.id) {
				AppStore.dispatch(CreditAction.fetchUserInitCredit(login))
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		if (!this.props.stations.length && nextProps.families.length !== this.props.families.length && nextProps.families.length) {
			const types = uniq(flattenDeep(nextProps.families.map(f => {
				const themes = f.themes.filter(t => !t.disable)
				return themes.map(t => t.siteTypes.map(o => o.type))
			})))
			AppStore.dispatch(ReferentialAction.fetchSimpleStations(types))
		}
	}

	componentDidMount() {
		$('.button-collapse').sideNav()
	}

	getLogged = () => {
		const token = sessionStorage.getItem('TOKEN')
		return !(!token || !atob(token))
	}

	render() {
		const isLogged = this.getLogged()
		putAnalyticsCookieUser(this.props.user.login)
		return (
			<div>
				<header>
					<Header isLogged={ isLogged }/>
					<SideNav isLogged={ isLogged }/>
				</header>
				<main>
					{ this.props.children && React.cloneElement(this.props.children, {
						login: this.state.login, user: this.props.user, typeId: this.props.typeId, isLogged: isLogged
					}) }
					<Help/>
				</main>
				<Wait/>
				<Tutorial open={ this.props.user.firstConnection }/>
				<CookiePanel user={ this.props.user.login }/>
				<LoginModal/>
				<ToastrPanel/>
				<InformationPanel/>
			</div>
		)
	}
}

AquadbApp.propTypes = {
	children: PropTypes.element,
	success: PropTypes.string,
	error: PropTypes.string,
	wait: PropTypes.bool,
	typeId: PropTypes.number,
	user: PropTypes.instanceOf(DtoUser),
	units: PropTypes.arrayOf(PropTypes.instanceOf(DtoUnit)),
	remarks: PropTypes.arrayOf(PropTypes.instanceOf(DtoRemark)),
	supports: PropTypes.arrayOf(PropTypes.instanceOf(DtoSupport)),
	standardCodifications: PropTypes.arrayOf(PropTypes.instanceOf(DtoStandardCodification)),
	parameters: PropTypes.arrayOf(PropTypes.instanceOf(DtoParameter)),
	cities: PropTypes.arrayOf(PropTypes.instanceOf(DtoCity)),
	departments: PropTypes.arrayOf(PropTypes.instanceOf(DtoDepartment)),
	filterTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoFilterType)),
	siteTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoSiteType)),
	watersheds: PropTypes.arrayOf(PropTypes.instanceOf(DtoWatershed)),
	stations: PropTypes.arrayOf(PropTypes.instanceOf(DtoSimpleStation)),
	userCredit: PropTypes.instanceOf(DtoUserCredit),
	creditTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoCreditType)),
	selections: PropTypes.arrayOf(PropTypes.instanceOf(DtoSelection)),
	indicatorTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoIndicatorType)),
	indicators: PropTypes.arrayOf(PropTypes.instanceOf(DtoIndicator)),
	managementWaters: PropTypes.arrayOf(PropTypes.instanceOf(DtoManagementWater)),
	families: PropTypes.arrayOf(PropTypes.instanceOf(MasterThemeDto)),
	sources: PropTypes.arrayOf(PropTypes.instanceOf(DtoSource)),
	selectionStatus: PropTypes.arrayOf(PropTypes.instanceOf(DtoSelectionStatus))
}

const mapStateToProps = store => {
	return {
		success: store.HomeReducer.success,
		error: store.HomeReducer.error,
		wait: store.HomeReducer.wait,
		user: store.HomeReducer.user,
		units: store.ReferentialReducer.units,
		remarks: store.ReferentialReducer.remarks,
		supports: store.ReferentialReducer.supports,
		standardCodifications: store.ReferentialReducer.standardCodifications,
		parameters: store.ReferentialReducer.parameters,
		cities: store.ReferentialReducer.cities,
		departments: store.ReferentialReducer.departments,
		filterTypes: store.ReferentialReducer.filterTypes,
		siteTypes: store.ReferentialReducer.siteTypes,
		watersheds: store.ReferentialReducer.watersheds,
		stations: store.ReferentialReducer.stations,
		userCredit: store.CreditReducer.userCredit,
		creditTypes: store.CreditReducer.creditTypes,
		selections: store.SelectionReducer.selections,
		selectionStatus: store.SelectionReducer.selectionStatus,
		indicatorTypes: store.ReferentialReducer.indicatorTypes,
		indicators: store.ReferentialReducer.indicators,
		managementWaters: store.ReferentialReducer.managementWaters,
		families: store.AdministrationReducer.themes,
		sources: store.AdministrationReducer.sources
	}
}

export default connect(mapStateToProps)(AquadbApp)



// WEBPACK FOOTER //
// ./src/home/components/AquadbApp.js